import { render, staticRenderFns } from "./DialogAssuntos.vue?vue&type=template&id=00af7fb3"
import script from "./DialogAssuntos.vue?vue&type=script&lang=js"
export * from "./DialogAssuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports